import i18n from 'src/plugins/i18n'

export async function SOCKET_trainingSessionClosed ({ dispatch }) {
  await dispatch('logout')
  const notification = i18n.t('login.message.sessionClosed')
  dispatch('ui/showSuccessNotification', notification, { root: true })
}
